import * as firebase from "firebase/app";
import { signupViaSNS } from '@/api/sns-user';
import user_util from '@/utils/UserUtils'



export function googleSignInPopup(additional_data){
    return new Promise((resolve, reject) => {
        var provider = new firebase.auth.GoogleAuthProvider();

        firebase.auth().signInWithPopup(provider).then( (result) => {
            if(result.additionalUserInfo){
                let pd_meta = result.additionalUserInfo;

                if(pd_meta.isNewUser){
                    // Save New user Data 
                    // pd_meta.profile
                    newRegister(result, additional_data)
                        .then(res => {
                            resolve(res)
                        })
                        .catch(err => {
                            firebase.auth().onAuthStateChanged(user => {
                                if (!user) reject(err.response);
    
                                user.delete().then(result => {
                                    reject(err.response);
                                }).catch(error => {
                                    reject(error)
                                });
                            })                            
                        })
                }else{
                    resolve(result);
                }
            }else{
                resolve(result);
            }
          }).catch((error) => {
                reject(error);
          });        
    })
}


/**
 * Register new user Data to DB
 * @param {*} googleUser 
 */
export function newRegister(result, additional_data) {
    return new Promise((resolve, reject) => {
        // console.log(result.additionalUserInfo);
        let pd_meta = result.additionalUserInfo;
        let bDay = (pd_meta.profile.birthday)? user_util.getDate(pd_meta.profile.birthday) : '',
            params = {
                email: pd_meta.profile.email,
                birthday: (bDay)? `${bDay.year}/${bDay.month}/${bDay.day}`: null,
                gender: pd_meta.profile.gender,
                user_family_name: pd_meta.profile.family_name,
                user_first_name: pd_meta.profile.given_name,
                language_id: parseInt(additional_data.language_id),
                sns_registration: 'true',
                user_nickname: pd_meta.profile.name,
                snsId: (pd_meta.profile.id)?pd_meta.profile.id:pd_meta.profile.sub,
                firebase_uid: result.user.uid, // Firebase UID
                accessToken: result.credential.accessToken
            }

        signupViaSNS(params).then((data) => {
            resolve(data)
        }).catch(error => {
            reject(error.response)
        })
    })
}





/**
 * ***************************:: Un-necessary ::**********************
 */

export function gogoleSignInRedirectResult(){
    firebase.auth().getRedirectResult().then(function(result) {
        if (result.credential) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          // ...
        }
        console.log(result);
        // The signed-in user info.
        var user = result.user;
      }).catch(function(error) {

        console.log(error);
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });    
}


// WEBPACK FOOTER //
// ./src/auth/google.js